export const Images = {
    Dashboard: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/dashboard.png",
    Session: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/calendar.png",
    CourtBooking: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/tennis-court.png",
    HolidayCamp: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/holiday-camp.png",
    SetUp: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/gear.png",
    Email: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/email.png",
    Member: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/people.png",
    Report: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/analysis.png",
    TermSession: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/term.png",
    WeeklySession: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/week.png",
    MonthlySession: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/month.png",
    TermsAndConditions: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/t&c.png",
    PaymentReport: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/business-credit-report.png",
    SchoolSession: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/school.png",
    Events: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/events.png",
    Inventory: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/inventory-management.png",
    Shop: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/shop.png",
    AllProducts: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/all_products.png",
    ActiveProducts: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/active_products.png",
    InactiveProducts: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/inactive_products.png",
    OutOfStock: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/out_of_stock.png",
    ComingSoon: "https://d1ybtjfafmsyx2.cloudfront.net/webadminassets/coming-soon.png",
    ManageOrders: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/orders_manage.png",
    ManageMenu: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/menu.png",
    LockRegistry: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/lock.png",
    LockManagement: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/lock_manage.png",
    ManageCredits: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/lock_credits.png",
    Polls: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/poll.png",
    Permissions: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/permission-management.png",
    Competitions: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/trophy.png",
    Wallet: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/wallet.png",
    Membership: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/membership.png",
    Notification: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/notification.png",
    HelpFeedback: "https://d1ybtjfafmsyx2.cloudfront.net/iconpack/support.png",
}